@for (entry of entries(); track entry.id) {
  <div
    #panel
    [attr.data-dropdown-id]="entry.id"
    [class]="panelClasses(entry)"
    [style.opacity]="entry.visible ? 1 : 0"
    [style.pointer-events]="entry.visible ? 'auto' : 'none'"
    [style.width.px]="entry.opts.width ? entry.opts.width : null"
    [style.min-width.px]="entry.opts.minWidth ?? 0"
    [style.min-height.px]="entry.opts.minHeight ?? 0"
    [style.max-width.px]="entry.opts.maxWidth ? entry.opts.maxWidth : null"
    [style.max-height.px]="entry.opts.maxHeight ? entry.opts.maxHeight : null"
    [style.overflow-y]="entry.opts.maxHeight ? 'auto' : null"
    (click)="onPanelClick($event)"
    (keydown)="$event.stopPropagation()">
    <ng-container
      [ngTemplateOutlet]="entry.template"
      [ngTemplateOutletContext]="entry.context" />
  </div>
}
